import * as R from 'ramda';

const getAccessToken = R.path(['auth', 'accessToken']);

export default getAccessToken;
